<template>
    <li>
        <router-link :to="'/'+item.page.post_name">
            <span>{{ item.page.post_title }}.</span>
        </router-link> 
    </li>
</template>

<script>
export default {
    props: ['item']
}
</script>
